import { AxiosInstance } from "axios"
import { CompaniesUsersItem } from "../../../../users/userTypes"

export enum CompanyAdminUsersQuery {
    USERS_FOR_COMPANY = "users-for-company",
}

export type CompaniesUsersParams = Readonly<{
    companyId: number
    userGroupId?: number
    search?: string
}>

export type CompaniesUsersResponse = Readonly<{
    users: CompaniesUsersItem[]
}>

export async function fetchCompaniesUsers(
    { companyId, userGroupId, search }: CompaniesUsersParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CompaniesUsersResponse> {
    const url = `/companies/${companyId}/users`
    const { data } = await axios.get(url, {
        params: {
            userGroupId,
            search,
        },
        signal,
    })

    return data
}
